<!-- src/App.vue -->
<template>
  <div>
    <!-- 顶部导航栏 -->
    <el-header class="app-header">
      <div class="logo">医疗纠纷律师信息查询</div>
      <div>
        <el-button v-if="isLoggedIn" type="warning" @click="handleLogout">
          <el-icon><switch-button /></el-icon>

          安全退出
        </el-button>
      </div>
    </el-header>

    <!-- 页面主体 -->
    <el-main>
      <router-view />
    </el-main>

    <!-- 底部版权信息 -->
    <el-footer class="app-footer">
      © 2025 医疗纠纷法律服务. 联系电话：123-4567-890
    </el-footer>
  </div>
</template>

<script>
import { ref, watch } from 'vue' // 新增 watch
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import Cookies from 'js-cookie'

export default {
  name: 'App',
  setup() {
    const router = useRouter()
    // 基于 Cookies 判断登录状态
    const isLoggedIn = ref(!!Cookies.get('user_token'))

    // 新增：监听 Cookie 变化
    const checkLoginStatus = () => {
      isLoggedIn.value = !!Cookies.get('user_token')
    }

    // 每秒检查一次（可根据需要调整频率）
    setInterval(checkLoginStatus, 300)

    // 或使用更高效的 watch
    // 修复后的 watch 监听
    watch(
      () => Cookies.get('user_token'), // 响应式依赖
      (newValue) => { // 参数名修正
        isLoggedIn.value = !!newValue
      }
    )
    const handleLogout = async () => {
      try {
        // 二次确认弹窗
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        // 清除登录状态
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        // 跳转登录页并提示
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        // 用户取消退出时不执行操作
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    return {
      isLoggedIn,
      handleLogout
    }
  }
}
</script>

<style scoped>
.app-header {
  background: #1F2937;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  height: 60px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.logo {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
}

.el-main {
  min-height: calc(100vh - 140px);
  padding: 30px 50px;
  background: #f8fafc;
}

.app-footer {
  background: #F5F7FA;
  color: #666;
  line-height: 50px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
}

/* 自定义确认框样式 */
:deep(.logout-confirm) {
  width: 450px;

  .el-message-box__header {
    background: #f8fafc;
    padding: 20px;
  }

  .el-message-box__content {
    padding: 30px 20px;
    font-size: 16px;
  }

  .el-message-box__btns {
    justify-content: center;
    padding: 20px;

    button:first-child {
      background: #dc3545;
      border-color: #dc3545;
    }
  }
}
</style>